document.addEventListener('DOMContentLoaded', () => {
  const heart = document.querySelector('.happy-marquee__heart');

  if (!heart) return;

  let ticking = false;

  window.addEventListener('scroll', () => {
    if (ticking) return;

    ticking = true;
    heart.classList.add('is-beating');

    setTimeout(() => {
      heart.classList.remove('is-beating');
      ticking = false;
    }, 450);
  });
});